import type { ILangData } from "@/queries/useTranslations";
import type { IContentType, ILanguage } from "@/types";

interface ISearchCache {
    texts: {
        [index: string]: {
            [index: string]: {
                obj: object;
                context: string;
                result: string;
            };
        };
    };
    docs: {
        [index: string]: {
            [index: string]: {
                obj: object;
                context: string;
                result: string;
            };
        };
    };
    defaultContent: {
        [index: string]: {
            [index: string]: {
                obj: object;
                context: string;
                result: string;
            };
        };
    };
}

const searchCache: ISearchCache = {
    texts: {},
    docs: {},
    defaultContent: {},
};

export function getSearchString(
    contentType: IContentType,
    id: string,
    obj: ILangData,
    langs: ILanguage[],
    obj2: Partial<ILangData> | undefined,
    context: string,
): string {
    const langString = langs.join("");
    let entry = searchCache[contentType][id]?.[langString];
    if (!entry) {
        if (!searchCache[contentType][id]) {
            searchCache[contentType][id] = {};
        }
        entry = searchCache[contentType][id][langString] = {
            obj: obj2 ?? obj,
            context,
            result: "",
        };
    }
    if (!entry.result || entry.obj !== (obj2 ?? obj) || entry.context !== context) {
        entry.obj = obj2 ?? obj;
        entry.context = context;
        const translationText = Object.entries(obj)
            .filter(([lang, _val]) => langs.includes(lang as ILanguage))
            .map(([lang, val]) => {
                const out = obj2?.[lang as ILanguage] ?? val ?? "";
                return out.toLowerCase();
            })
            .join(" ");
        entry.result = `${context.toLowerCase()} ${translationText}`.trim();
    }
    return entry.result;
}
